var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { baseColors } from '../../../Themes/colors';
export var FundingLogTableRoot = styled(Box)({
    backgroundColor: baseColors.fullWhite,
    border: "1px solid ".concat(baseColors.greyPreset[40]),
    borderRadius: 8,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
});
export var FundingLogScrollArea = styled(Box)({
    flex: '1 1 auto',
    minHeight: 0,
    overflow: 'auto',
});
export var FundingLogTableInner = styled(Box)({
    width: 'fit-content',
    minWidth: '100%',
});
export var FundingLogHeaderRow = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    gap: 0,
    width: '100%',
    borderBottom: "1px solid ".concat(baseColors.greyPreset[40]),
    minWidth: 'fit-content',
    position: 'sticky',
    top: 0,
    zIndex: 3,
    backgroundColor: baseColors.fullWhite,
});
export var FundingLogHeaderCell = styled(Box, {
    shouldForwardProp: function (prop) { return prop !== 'sortable'; },
})(function (_a) {
    var sortable = _a.sortable;
    return ({
        flex: '1 0 0',
        minWidth: 140,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        padding: '8px 10px',
        cursor: sortable ? 'pointer' : 'default',
        '& .sort-label': {
            fontFamily: "'Nunito', sans-serif",
            fontWeight: 700,
            fontSize: 11,
            letterSpacing: 1,
            textTransform: 'uppercase',
            color: baseColors.darkPreset[10],
            textAlign: 'left',
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            lineHeight: 1.3,
        },
        '& .icon-import_export': {
            fontSize: 16,
            color: baseColors.greyPreset[30],
            flexShrink: 0,
        },
    });
});
export var FundingLogGroupHeaderRow = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    padding: '12px 16px',
    backgroundColor: baseColors.successPreset[20],
    borderBottom: "1px solid ".concat(baseColors.greyPreset[40]),
    '& .group-label': {
        fontFamily: "'Nunito', sans-serif",
        fontWeight: 700,
        fontSize: 13,
        color: baseColors.darkPreset[10],
    },
});
export var FundingLogEmptyRow = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    width: '100%',
    gap: 8,
    padding: '64px 24px',
    '& .empty-label': {
        fontFamily: "'Nunito', sans-serif",
        fontSize: 13,
        color: baseColors.greyPreset[10],
    },
    '& .empty-title': {
        fontFamily: "'Nunito', sans-serif",
        fontSize: 18,
        fontWeight: 800,
        color: baseColors.darkPreset[10],
    },
    '& .empty-subtitle': {
        fontFamily: "'Nunito', sans-serif",
        fontSize: 14,
        color: baseColors.greyPreset[30],
        maxWidth: 480,
    },
});
export var FundingLogNewTag = styled(Box)({
    display: 'inline-flex',
    alignItems: 'center',
    padding: '1px 8px',
    borderRadius: 10,
    backgroundColor: '#E3F2EF',
    color: baseColors.successPreset[30],
    fontFamily: "'Nunito', sans-serif",
    fontWeight: 700,
    fontSize: 11,
    lineHeight: '16px',
    whiteSpace: 'nowrap',
});
var NEW_ACCENT = '#3E8B7C';
export var FundingLogNewRowTag = styled(Box)({
    display: 'inline-flex',
    alignItems: 'center',
    padding: '2px 8px',
    borderRadius: 6,
    backgroundColor: NEW_ACCENT,
    boxShadow: "0 0 0 2px ".concat(NEW_ACCENT, "33"),
    color: baseColors.fullWhite,
    fontFamily: "'Nunito', sans-serif",
    fontWeight: 800,
    fontSize: 10,
    letterSpacing: '0.08em',
    lineHeight: '14px',
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
});
var NEW_ROW_BACKGROUND = '#F4FAF7';
export var FundingLogRowWrapper = styled(Box, {
    shouldForwardProp: function (prop) { return prop !== 'isSelected' && prop !== 'isNew'; },
})(function (_a) {
    var isSelected = _a.isSelected, isNew = _a.isNew;
    return (__assign(__assign(__assign({ display: 'flex', alignItems: 'center', gap: 0, width: '100%', minHeight: 42, borderBottom: "1px solid ".concat(baseColors.greyPreset[40]), minWidth: 'fit-content', transition: 'background-color 0.12s' }, (isNew && {
        backgroundColor: NEW_ROW_BACKGROUND,
        boxShadow: "inset 4px 0 0 ".concat(NEW_ACCENT),
        '& .funding-log-action-cell': {
            backgroundColor: NEW_ROW_BACKGROUND,
        },
    })), (isSelected && {
        backgroundColor: baseColors.greyPreset[45],
        '& .funding-log-action-cell': {
            backgroundColor: baseColors.greyPreset[45],
        },
    })), { '&:hover': {
            backgroundColor: isSelected ? baseColors.greyPreset[45] : baseColors.successPreset[20],
        }, '&:hover .funding-log-actions-default': {
            display: 'none',
        }, '&:hover .funding-log-actions-hover': {
            display: 'flex',
        }, '&:hover .funding-log-action-cell': {
            backgroundColor: isSelected ? baseColors.greyPreset[45] : baseColors.successPreset[20],
        }, '&:last-of-type': {
            borderBottom: 'none',
        } }));
});
export var FundingLogRowActions = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    gap: 4,
});
export var FundingLogActionsDefault = styled(Box)({
    display: 'flex',
    alignItems: 'center',
});
export var FundingLogActionsOnHover = styled(Box)({
    display: 'none',
    alignItems: 'center',
    gap: 4,
});
export var FundingLogCell = styled(Box)({
    flex: '1 0 0',
    minWidth: 140,
    padding: '8px 10px',
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
});
var FUNDING_LOG_ACTION_COLUMN_WIDTH = 72;
var FUNDING_LOG_ACTION_PINNED_SHADOW = '-6px 0 10px -6px rgba(0, 0, 0, 0.16)';
export var FundingLogActionHeaderCell = styled(Box, {
    shouldForwardProp: function (prop) { return prop !== 'isPinned'; },
})(function (_a) {
    var isPinned = _a.isPinned;
    return ({
        flex: "0 0 ".concat(FUNDING_LOG_ACTION_COLUMN_WIDTH, "px"),
        width: FUNDING_LOG_ACTION_COLUMN_WIDTH,
        minWidth: FUNDING_LOG_ACTION_COLUMN_WIDTH,
        padding: '8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'sticky',
        right: 0,
        zIndex: 4,
        backgroundColor: baseColors.fullWhite,
        borderLeft: "1px solid ".concat(baseColors.greyPreset[40]),
        boxShadow: isPinned ? FUNDING_LOG_ACTION_PINNED_SHADOW : 'none',
        transition: 'box-shadow 0.15s',
        '& .sort-label': {
            fontFamily: "'Nunito', sans-serif",
            fontWeight: 700,
            fontSize: 12,
            letterSpacing: 1,
            textTransform: 'uppercase',
            color: baseColors.darkPreset[10],
        },
    });
});
export var FundingLogActionCell = styled(Box, {
    shouldForwardProp: function (prop) { return prop !== 'isPinned'; },
})(function (_a) {
    var isPinned = _a.isPinned;
    return ({
        flex: "0 0 ".concat(FUNDING_LOG_ACTION_COLUMN_WIDTH, "px"),
        width: FUNDING_LOG_ACTION_COLUMN_WIDTH,
        minWidth: FUNDING_LOG_ACTION_COLUMN_WIDTH,
        padding: '8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'sticky',
        right: 0,
        zIndex: 2,
        backgroundColor: baseColors.fullWhite,
        borderLeft: "1px solid ".concat(baseColors.greyPreset[40]),
        boxShadow: isPinned ? FUNDING_LOG_ACTION_PINNED_SHADOW : 'none',
        transition: 'background-color 0.12s, box-shadow 0.15s',
    });
});
export var FundingLogContractLink = styled(Box)({
    fontFamily: "'Nunito', sans-serif",
    fontWeight: 700,
    fontSize: 14,
    color: baseColors.successPreset[30],
});
export var FundingLogAmountText = styled(Box)({
    fontFamily: "'Nunito', sans-serif",
    fontWeight: 700,
    fontSize: 14,
    color: baseColors.darkPreset[10],
});
export var FundingLogStatusPill = styled(Box)({
    display: 'inline-block',
    verticalAlign: 'middle',
    boxSizing: 'border-box',
    padding: '4px 6px',
    borderRadius: 4,
    backgroundColor: baseColors.bluePreset[60],
    color: baseColors.bluePreset[50],
    fontFamily: "'Nunito', sans-serif",
    fontWeight: 500,
    fontSize: 10,
    whiteSpace: 'nowrap',
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
});
export var FundingLogCommentsPill = styled(Box)({
    display: 'inline-flex',
    alignItems: 'center',
    gap: 4,
    padding: '4px 6px',
    borderRadius: 4,
    backgroundColor: baseColors.bluePreset[90],
    color: baseColors.fullWhite,
    fontFamily: "'Nunito', sans-serif",
    fontWeight: 500,
    fontSize: 10,
    whiteSpace: 'nowrap',
    '& svg': {
        fontSize: 12,
    },
});
export var FundingLogViewButton = styled(Button)({
    display: 'inline-flex',
    alignItems: 'center',
    gap: 4,
    padding: '4px 8px',
    borderRadius: 4,
    border: "1px solid ".concat(baseColors.greyPreset[40]),
    backgroundColor: baseColors.fullWhite,
    color: baseColors.greyPreset[10],
    fontFamily: "'Nunito', sans-serif",
    fontWeight: 500,
    fontSize: 12,
    textTransform: 'none',
    minWidth: 'auto',
    lineHeight: 1.4,
    whiteSpace: 'nowrap',
    '&:hover': {
        backgroundColor: baseColors.greyPreset[55],
    },
});
export var FundingLogAssignButton = styled(Button)({
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    padding: '6px 12px',
    borderRadius: 16,
    backgroundColor: baseColors.successPreset[30],
    color: baseColors.fullWhite,
    fontFamily: "'Nunito', sans-serif",
    fontWeight: 500,
    fontSize: 12,
    textTransform: 'none',
    minWidth: 'auto',
    lineHeight: 1.4,
    whiteSpace: 'nowrap',
    '&:hover': {
        backgroundColor: baseColors.successPreset[10],
    },
    '& .icon-profile': {
        fontSize: 14,
    },
});
export var FundingLogComposerWrapper = styled(Box)({
    padding: 16,
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    flexShrink: 0,
    borderTop: "1px solid ".concat(baseColors.greyPreset[40]),
    backgroundColor: "".concat(baseColors.successPreset[30], "0D"),
    borderLeft: "3px solid ".concat(baseColors.successPreset[30]),
    '& .subjectInput': {
        width: '100%',
        padding: '8px 12px',
        border: "1px solid ".concat(baseColors.greyPreset[40]),
        borderRadius: 8,
        fontSize: 13,
        outline: 'none',
        fontFamily: "'Nunito', sans-serif",
        color: baseColors.darkPreset[10],
        backgroundColor: baseColors.fullWhite,
        boxSizing: 'border-box',
        transition: 'border-color 0.12s',
        '&::placeholder': {
            color: baseColors.greyPreset[30],
        },
        '&:hover:not(:disabled)': {
            borderColor: baseColors.successPreset[30],
        },
        '&:focus': {
            borderColor: baseColors.successPreset[30],
            borderWidth: 2,
            padding: '7px 11px',
        },
        '&:disabled': {
            backgroundColor: baseColors.greyPreset[55],
        },
    },
    '& .textareaWrap': {
        position: 'relative',
    },
    '& .messageTextarea': {
        width: '100%',
        minHeight: 72,
        padding: '10px 44px 10px 12px',
        border: "1px solid ".concat(baseColors.greyPreset[40]),
        borderRadius: 8,
        fontSize: 13,
        outline: 'none',
        fontFamily: "'Nunito', sans-serif",
        resize: 'none',
        color: baseColors.darkPreset[10],
        backgroundColor: baseColors.fullWhite,
        boxSizing: 'border-box',
        display: 'block',
        transition: 'border-color 0.12s',
        '&::placeholder': {
            color: baseColors.greyPreset[30],
        },
        '&:hover:not(:disabled)': {
            borderColor: baseColors.successPreset[30],
        },
        '&:focus': {
            borderColor: baseColors.successPreset[30],
            borderWidth: 2,
            padding: '9px 43px 9px 11px',
        },
        '&:disabled': {
            backgroundColor: baseColors.greyPreset[55],
        },
    },
    '& .sendBtn': {
        position: 'absolute',
        bottom: 8,
        right: 8,
        width: 32,
        height: 28,
        borderRadius: 4,
        border: 'none',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        '&:disabled': {
            cursor: 'not-allowed',
        },
    },
});
